import React, { useEffect, useRef } from "react";
import { View, StyleSheet, TouchableOpacity, Animated, Easing } from "react-native";
import config from "../config/config";
import AppText from "./AppText";
import useProducts from "../hooks/useProducts";
import ImageCarousel from "./ImageCarousel";
import useUser from "../hooks/useUser";
import Icon from "./Icon";
import ImageCarouselReskin from "./ImageCarouselReskin";

function ListingCardReskin({ product, navigation }) {
    const { setProductStatus } = useProducts();
    const { user } = useUser();

    const glowValue = useRef(new Animated.Value(0)).current;
    const springValue = useRef(new Animated.Value(1)).current;

    const spring = () => {
        glowValue.setValue(0);
        Animated.timing(glowValue, {
            toValue: 2,
            duration: 400,
            useNativeDriver: false,
        }).start(() => navigation.navigate("ProductDetails", product));

        springValue.setValue(0.9);
        Animated.spring(springValue, {
            toValue: 1,
            friction: 4,
            useNativeDriver: false,
        }).start();
    };

    return (
        <Animated.View
            style={{
                overflow: "hidden",
                borderRadius: 20,
                backgroundColor: config.colors.white,
                borderColor: glowValue.interpolate({
                    inputRange: [0, 0.1, 2],
                    outputRange: [config.colors.primary, config.colors.green, config.colors.primary],
                }),

                shadowColor: "#171717",
                shadowOffset: { width: -2, height: 4 },
                shadowOpacity: 0.2,
                shadowRadius: 3,
                margin: 10,
                flex: 1,
                transform: [{ scale: springValue }],
            }}
        >
            <TouchableOpacity onPress={() => spring()}>
                <View style={{ flexDirection: "row", marginTop: 10, paddingHorizontal: 20 }}>
                    <AppText numberOfLines={3} style={styles.subTitle}>
                        {product.description}
                    </AppText>
                </View>
                <ImageCarouselReskin imageData={product.images} enableUpload={false} navigation={navigation} />
                <View style={styles.cardBody}>
                    <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                        <View>
                            <View style={{ flexDirection: "row", marginTop: 10, paddingHorizontal: 10 }}>
                                <AppText style={styles.title}>Engine Code: </AppText>
                                <AppText style={styles.subTitle}>{product.vehicle.engineCode} </AppText>
                            </View>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 10, paddingHorizontal: 10 }}>
                            <AppText style={styles.title}>Category: </AppText>
                            <AppText style={styles.subTitle}>{product.category} </AppText>
                        </View>
                    </View>
                    <View style={{ flexDirection: "row", marginTop: 10, marginHorizontal: 10 }}>
                        <AppText style={styles.title}>Price: </AppText>
                        <AppText style={styles.subTitle}>£{product.price}</AppText>
                    </View>
                </View>
                {user.type == "admin" && (
                    <View style={styles.footer}>
                        {product.status == "for sale" && (
                            <View style={styles.buttonContainer}>
                                <TouchableOpacity onPress={async () => setProductStatus(product._id, "sold")} style={styles.buttonLeft}>
                                    <AppText style={styles.buttonText}>Mark as Sold</AppText>
                                </TouchableOpacity>
                                <TouchableOpacity onPress={async () => setProductStatus(product._id, "archive")} style={styles.buttonRight}>
                                    <AppText style={styles.buttonText}>Archive</AppText>
                                </TouchableOpacity>
                            </View>
                        )}
                    </View>
                )}
            </TouchableOpacity>
        </Animated.View>
    );
}

const styles = StyleSheet.create({
    title: {
        fontSize: 14,
        fontWeight: "800",
        color: "#D2D2D2",
    },
    price: {
        fontSize: 14,
        fontWeight: "800",
        color: config.colors.danger,
    },
    subTitle: {
        fontSize: 14,
        fontWeight: "800",
        color: config.colors.black,
    },
    card: {
        backgroundColor: config.colors.white,
        overflow: "hidden",
        borderRadius: 20,
        // borderColor: config.colors.black,
        // borderWidth: 2,
        margin: 10,
        flex: 1,
    },
    cardBody: {
        justifyContent: "space-between",
        marginHorizontal: 5,
        marginBottom: 10,
        backgroundColor: config.colors.white,
    },
    header: {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    },
    footer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
    },
    statusBarText: {
        fontWeight: "700",
        fontSize: 18,
        textTransform: "capitalize",
        color: config.colors.black,
    },
    buttonText: {
        fontWeight: "700",
        fontSize: 14,
        textTransform: "capitalize",
        color: config.colors.white,
    },
    buttonContainer: {
        flexDirection: "row",
        flex: 1,
        paddingBottom: 10,
        paddingHorizontal: 10,
    },
    buttonLeft: {
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 5,
        paddingTop: 10,
        paddingBottom: 10,
        borderColor: config.colors.white,
        backgroundColor: config.colors.red,
        flex: 1,
        marginRight: 5,
    },
    buttonRight: {
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 5,
        paddingTop: 10,
        paddingBottom: 10,
        backgroundColor: config.colors.red,
        borderColor: config.colors.white,
        flex: 1,
        marginLeft: 5,
    },
    buttonCenter: {
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 20,
        backgroundColor: config.colors.primary,
        borderColor: config.colors.white,
        flex: 1,
    },
    logo: {
        flex: 1,
    },
});

export default ListingCardReskin;
